// Company and Platform Information
export const companyData = {
  name: "Empresa ABC",
  nameEn: "Company ABC",
  shortName: "ABC",
  location: "Lunda Norte, Angola",
};

export const platformData = {
  name: {
    en: "Executive Cockpit for Mining",
    pt: "Cockpit Executivo para a Mineração"
  }
};
